// Package Imports
import { z } from 'zod'

const adminValidationErrors = {
  name: {
    required: 'Kullanıcı adı zorunludur.',
    min: 'Kullanıcı adı en az 2 karakter olmalıdır.',
    noWhitespace: 'Kullanıcı adı boşluk içeremez.',
  },
  email: {
    invalid: 'Geçerli bir e-posta giriniz.',
  },
  password: {
    required: 'Şifre zorunludur.',
    min: 'Şifre en az 6 karakter olmalıdır.',
    uppercase: 'Şifre en az bir büyük harf içermelidir.',
    specialChar: 'Şifre en az bir özel karakter içermelidir.',
  },
  confirmPassword: {
    required: 'Şifre tekrarı zorunludur.',
    min: 'Şifre tekrarı en az 6 karakter olmalıdır.',
    match: 'Şifreler eşleşmiyor.',
  },
  role: {
    required: 'En az bir rol seçmelisiniz.',
  },
} as const

const { name, email, password, confirmPassword, role } = adminValidationErrors

export const adminUsersSearchSchema = z.object({
  page: z.number().optional(),
  query: z.string().optional(),
})

export const createAdminSchema = z
  .object({
    name: z.string().min(1, name.required).min(2, name.min).max(100),
    email: z.email({
      error: email.invalid,
    }),
    password: z.string().min(1, password.required).min(6, password.min),
    confirm_password: z
      .string()
      .min(1, confirmPassword.required)
      .min(6, confirmPassword.min),
  })
  .refine((v) => v.password === v.confirm_password, {
    message: confirmPassword.match,
    path: ['confirm_password'],
  })

export const editAdminSchema = z.object({
  role_ids: z.array(z.string()).min(1, role.required),
})
